const sell = (state) => state;

export default {
    sell,
};
